import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
/* import { PlayerService } from 'src/app/shared/player.service';
import { FlowItemViewModel } from '../models/FlowItemModel';
import { ReportSearchParameters } from '../models/ReportSearchParameters';
import { ScoutingPlayerService } from '../services/scouting-player.service'; */
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
/* import { PlayerViewDialogComponent } from '../player-view-dialog/player-view-dialog.component';
import { ReportViewDialogComponent } from '../report-view-dialog/report-view-dialog.component'; */
import { MatDialogConfig } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PlayerService } from '../../../shared/services/player.service';
import { ScoutingPlayerService } from '../../../shared/services/scouting-player.service';
import { ReportSearchParameters } from '../../models/ReportSearchParameters';
import { FlowItemViewModel } from '../../../shared/models/FlowItemModel';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { ReportDetailsComponent } from '../../../scouting/screens/report-details/report-details.component';
import { ReportDetailsDialogComponent } from '../../../scouting/components/report-details-dialog/report-details-dialog.component';
import { Observable } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';



@Component({
    selector: 'app-report-search',
  imports: [CommonModule, RouterModule, ReactiveFormsModule, MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatTableModule, 
    MatPaginatorModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatToolbarModule, MatProgressBarModule, MatProgressSpinnerModule, MatIconModule, TranslatePipe, ReportDetailsDialogComponent
  //  ,PlayerViewDialogComponent, ReportViewDialogComponent, MatFormFieldModule,
  ],
    templateUrl: './report-search.component.html',
    styleUrls: ['./report-search.component.css']
})
export class ReportSearchComponent implements OnInit {
  private readonly desktopColumns: string[] = ['Player', 'DateOfBirth', 'DateCreated', 'TotalQualityText', 'PlayerCapacityText', 'CreatedBy', 'Actions'];
  private readonly mobileColumns: string[] = ['Player', 'TotalQualityText', 'Actions'];
  displayedColumns: string[] = this.desktopColumns;
  public dataSource= new MatTableDataSource<FlowItemViewModel>();
  isBusy: boolean;
  isSearchFormCollapsed = false;
  reportMasterdata$: Observable<any>;
  availableBirthYears: number[];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  searchForm = new UntypedFormGroup({
    PlayerFirstName: new UntypedFormControl(''),
    PlayerLastName: new UntypedFormControl('', Validators.required),
    PositionIds: new UntypedFormControl(''),
    YearsOfBirth: new UntypedFormControl(''),
    ShootIds: new UntypedFormControl(''),
    Projections: new UntypedFormControl(''),
    Capacities: new UntypedFormControl(''),
    MaxHits: new UntypedFormControl('50'),
    minReportDate:new UntypedFormControl(''),
    maxReportDate:new UntypedFormControl(''), 
  });
  
  constructor(public playerRep: PlayerService, public scoutingRep: ScoutingPlayerService,public matDialog: MatDialog,) { 

   
  }

  ngOnInit() {
    var earliestYear = new Date().getFullYear() - 13;

    this.reportMasterdata$ = this.scoutingRep.getReportSearchMasterDataForOrg();

    this.availableBirthYears =
    Array.from(
      { length: 45 },
      (value, index) => earliestYear - index 
      );
      //console.log("availableBirthYears");
      //console.log(this.availableBirthYears);

      this.updateDisplayedColumns(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event): void {
    const width = (event.target as Window).innerWidth;
    this.updateDisplayedColumns(width);
  }

  private updateDisplayedColumns(width: number): void {
    this.displayedColumns = width <= 430 ? this.mobileColumns : this.desktopColumns;
  }

  searchReports(){
    this.isSearchFormCollapsed = true;
    this.isBusy=true;

    try {
      //Clear result
      this.dataSource = new MatTableDataSource();
      var p: ReportSearchParameters;
      p = new ReportSearchParameters();
      p = this.searchForm.value;
   
      this.scoutingRep.searchReports(this.searchForm.value).subscribe( result=>{
          //console.log(result);
          this.dataSource = new MatTableDataSource(result);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          
      }); 
    } catch (error) {
      this.isBusy=false;
    }
    finally{
      this.isBusy = false;
    }

  }

  toggleSearchForm(): void {
    this.isSearchFormCollapsed = !this.isSearchFormCollapsed;
  }



  
  openPlayer(playerId:String) {
    const dialogConfig = new MatDialogConfig();
   /*  this.matDialog.open(PlayerViewDialogComponent, {
      data: { PlayerId: playerId },
    }); */
  }
  openViewReport(reportId:String) {
    const dialogConfig = new MatDialogConfig();
     this.matDialog.open(ReportDetailsDialogComponent, {
          width: '100vw',
      maxWidth: '450px',
      height: '100dvh',
      maxHeight: '100dvh',
      
       panelClass: 'side-dialog',
      position: {
        right: '0'
      },
      data: { ReportId: reportId },
    }); 
  }
}
